import React, { useState } from 'react';
import { Mail, Clock, Send, ShieldCheck, MessageSquare } from 'lucide-react';

const Contact = () => {
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    email: '',
    product: '',
    inquiryType: '',
    message: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    
    // Simulate support ticket submission
    setTimeout(() => {
      setIsSubmitting(false);
      setIsSubmitted(true);
      setFormData({
        firstName: '',
        lastName: '',
        email: '',
        product: '',
        inquiryType: '',
        message: ''
      });
      
      // Reset submission status after 4 seconds
      setTimeout(() => {
        setIsSubmitted(false);
      }, 4000);
    }, 1200);
  };

  return (
    <section id="contact" className="section contact">
      <div className="container">
        <div className="contact-container">
          <div className="contact-info animate-on-scroll">
            <span className="section-badge" style={{ background: 'rgba(25, 118, 210, 0.1)', color: 'var(--accent-color)' }}>User & Product Support</span>
            <h3>We Value User Feedback & Support</h3>
            <p>
              We build software products for real users. Whether you have product feedback, need technical support for an Android app, or have questions about <strong>JustSolar</strong>, our team is directly accessible.
            </p>
            
            <div className="contact-details">
              <div className="contact-item">
                <div className="contact-item-icon">
                  <Mail size={24} />
                </div>
                <div>
                  <strong>Product & Customer Support</strong>
                  <p><a href="mailto:pankajacharyaorg@gmail.com" style={{ color: 'inherit', textDecoration: 'none' }}>pankajacharyaorg@gmail.com</a></p>
                </div>
              </div>
              <div className="contact-item">
                <div className="contact-item-icon">
                  <MessageSquare size={24} />
                </div>
                <div>
                  <strong>General Inquiries & Support</strong>
                  <p><a href="mailto:pankajacharyaorg@gmail.com" style={{ color: 'inherit', textDecoration: 'none' }}>pankajacharyaorg@gmail.com</a></p>
                </div>
              </div>
              <div className="contact-item">
                <div className="contact-item-icon">
                  <Clock size={24} />
                </div>
                <div>
                  <strong>Response Window</strong>
                  <p>Within 24 business hours (Mon – Sat)</p>
                </div>
              </div>
              <div className="contact-item">
                <div className="contact-item-icon">
                  <ShieldCheck size={24} />
                </div>
                <div>
                  <strong>Legal Entity</strong>
                  <p>Pankaj Acharya (Sole Proprietor, JustLabs)</p>
                </div>
              </div>
            </div>
          </div>
          
          <div className="contact-form animate-on-scroll">
            <form onSubmit={handleSubmit}>
              <div className="form-row">
                <div className="form-group">
                  <label htmlFor="firstName">First Name *</label>
                  <input
                    type="text"
                    id="firstName"
                    name="firstName"
                    value={formData.firstName}
                    onChange={handleInputChange}
                    placeholder="Enter first name"
                    required
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="lastName">Last Name *</label>
                  <input
                    type="text"
                    id="lastName"
                    name="lastName"
                    value={formData.lastName}
                    onChange={handleInputChange}
                    placeholder="Enter last name"
                    required
                  />
                </div>
              </div>
              
              <div className="form-group">
                <label htmlFor="email">Email Address *</label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleInputChange}
                  placeholder="name@example.com"
                  required
                />
              </div>
              
              <div className="form-group">
                <label htmlFor="product">Software Product</label>
                <select
                  id="product"
                  name="product"
                  value={formData.product}
                  onChange={handleInputChange}
                >
                  <option value="">Select product (optional)</option>
                  <option value="justsolar">JustSolar (Solar EPC Suite)</option>
                  <option value="justpdf">Image to PDF - JustPDF</option>
                  <option value="justprint">JustPrint - Printable Notes</option>
                  <option value="justsaver">Status Saver - JustSaver</option>
                  <option value="justconverter">JPG to PNG - JustConverter</option>
                  <option value="general">General / Other Product</option>
                </select>
              </div>
              
              <div className="form-group">
                <label htmlFor="inquiryType">Inquiry Type</label>
                <select
                  id="inquiryType"
                  name="inquiryType"
                  value={formData.inquiryType}
                  onChange={handleInputChange}
                >
                  <option value="">Select reason for contact</option>
                  <option value="support">Technical / App Support</option>
                  <option value="feature">Feature Request & Suggestions</option>
                  <option value="justsolar-license">JustSolar Commercial License Query</option>
                  <option value="bug">Bug or Crash Report</option>
                  <option value="partnership">General Partnership</option>
                </select>
              </div>
              
              <div className="form-group">
                <label htmlFor="message">Message *</label>
                <textarea
                  id="message"
                  name="message"
                  rows="4"
                  placeholder="Tell us how we can help with your software inquiry, feedback, or support question..."
                  value={formData.message}
                  onChange={handleInputChange}
                  required
                />
              </div>
              
              <button 
                type="submit" 
                className="submit-btn"
                disabled={isSubmitting || isSubmitted}
              >
                {isSubmitting ? (
                  <>
                    <div className="spinner" style={{ width: '16px', height: '16px', marginRight: '8px' }}></div>
                    Sending...
                  </>
                ) : isSubmitted ? (
                  <>
                    <Send size={16} style={{ marginRight: '8px' }} />
                    Message Sent Successfully!
                  </>
                ) : (
                  <>
                    <Send size={16} style={{ marginRight: '8px' }} />
                    Submit Inquiry
                  </>
                )}
              </button>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;